import React from 'react';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
import { SmartLink } from '../SmartLink';
import { solutionCatalog } from '../../data/solutions/catalog';
import type { CustomerStory } from '../../types/story';
export function StoryCard({
  story
}: {
  story: CustomerStory;
}) {
  const industry = solutionCatalog[story.industry]?.title;
  return <SmartLink href={`/customers/${story.slug}`} className="group flex h-full flex-col" data-id="element-1622" data-mp="16xek89iog0wn">
      <div className="overflow-hidden rounded-[12px]" data-id="element-1623" data-mp="ab2wmptwogh6">
        <img src={story.image} alt={story.alt} loading="lazy" className="h-[240px] w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-1624" data-mp="f7jjlgpdcoso" />
      </div>
      <div className="mt-5 flex flex-wrap items-center gap-2" data-id="element-1625" data-mp="o27mj07h1ueb">
        {industry && <span className="rounded-full bg-canvas-warm px-2.5 py-1 text-[12px] font-medium text-ink" data-id="element-1626" data-mp="3nnd22139gacd">{industry}</span>}
        <span className="inline-flex items-center gap-1 text-[13px] text-ink-muted" data-id="element-1627" data-mp="3rnn6387hsqol">
          <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1628" data-mp="3ducst1v6bu8" />
          {story.location}
        </span>
      </div>
      <h3 className="mt-3 text-[18px] font-semibold tracking-[-0.02em] text-ink" data-id="element-1629" data-mp="3umrr95gg4mbp">{story.business}</h3>
      <p className="mt-2 text-[20px] font-semibold tracking-[-0.02em] text-brand" data-id="element-1630" data-mp="3prlwri8z9zc0">{story.result}</p>
      <p className="mt-2 text-[15px] leading-[1.5] text-ink-muted" data-id="element-1631" data-mp="3kt17gdv9l02c">{story.summary}</p>
      <span className="mt-auto inline-flex items-center gap-1.5 pt-4 text-[15px] font-medium text-brand" data-id="element-1632" data-mp="3ftoah0aoicm1">
        Read story
        <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-1633" data-mp="36v2xrlrw1rt6" />
      </span>
    </SmartLink>;
}